<template>
  <div class="container py-10">
    <ul
      v-if="categoriesDataAll?.length > 1"
      class="flex flex-wrap justify-center gap-2"
    >
      <li v-for="item in categoriesDataAll" :key="item.slug">
        <UiButton
          :to="item.slug === 'all' ? '/blog#list' : `/blog/${item?.slug}#list`"
          color="white"
          variant="outlined"
          size="sm"
          class="font-normal px-4 underline-offset-2"
          :class="{
            underline:
              route.params.section === item.slug ||
              (item.slug === 'all' && !route.params.section),
          }"
          content-class="flex items-center gap-x-1"
        >
          {{ item?.currentTranslation?.title }}
        </UiButton>
      </li>
    </ul>
    <form class="w-full max-w-[400px] mx-auto mt-8" @submit.prevent="onSearch">
      <UiInput
        v-model="search"
        :placeholder="$t('search')"
        prepend-icon="search"
        :hide-details="true"
        :lazy="false"
        color="white"
        class="text-white w-full"
      />
    </form>
  </div>
</template>

<script setup lang="ts">
import { BlogCategory } from "ecom-types";

const props = defineProps<{
  categoriesData: BlogCategory[];
}>();

const route = useRoute();
const router = useRouter();
const localePath = useLocalePathPolyfill();
const { t } = useI18n();
const search = ref(route.query.search || "");
let timeout: ReturnType<typeof setTimeout> | null = null;

const { searchEvent } = useEvents();

const categoriesDataAll = computed(() => {
  const allLink: Partial<BlogCategory> = {
    id: "all-link",
    slug: "all",
    currentTranslation: { title: t("allGems") },
    sort_order: -1,
  };

  return [allLink, ...props.categoriesData.filter((el) => el.status)];
});

watch(search, (val) => {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    onSearch();
    searchEvent(val);
  }, 400);
});

function onSearch() {
  const path = `/blog?search=${search.value}#list`;
  const localizedPath = localePath(path);
  router.push(localizedPath);
}
</script>
